import { CanvasHTMLAttributes, forwardRef, memo, ReactNode, useEffect, useImperativeHandle, useState } from 'react';

import { ZedEntity } from '../Entity';

import { useZed } from './useZed';

type ZedCanvasProps = Omit<CanvasHTMLAttributes<HTMLCanvasElement>, 'width' | 'height'> & {
  options?: Omit<ZedEntity['Canvas'], 'element'> & Record<string, any>;
  children?: ReactNode;
};

const _ZedCanvas = forwardRef<HTMLCanvasElement | undefined, ZedCanvasProps>(function _ZedCanvas(
  { options: canvasOptions, children, ...rest },
  ref
) {
  const zed = useZed();
  const [canvasRef, setCanvasRef] = useState<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (!zed || !canvasRef) return;

    const entity = zed.world.add({
      Canvas: {
        element: canvasRef,
        ...canvasOptions,
      },
    });

    return () => {
      zed.world.remove(entity);
    };
  }, [zed, canvasRef]);

  useImperativeHandle(ref, () => canvasRef ?? undefined, [canvasRef]);

  return (
    <canvas ref={setCanvasRef} {...rest}>
      {children}
    </canvas>
  );
});

export const ZedCanvas = memo(_ZedCanvas);
